import { render, staticRenderFns } from "./NotesContainer.vue?vue&type=template&id=7bbbd794&scoped=true&"
import script from "./NotesContainer.vue?vue&type=script&lang=js&"
export * from "./NotesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbbd794",
  null
  
)

export default component.exports